<app-purpose-type [userModel]="userModel"></app-purpose-type>
